export const SENDBIZ_TITLE =
  'Sendbiz is your source for discover companies,  jobs, products';

export const SENDBIZ_DESCRITPION =
  'Sendbiz is a platform that allows micro, small and medium sized companies to present information, jobs , products / service and events, they offer in an ergonomic way. Worldwide, we give great visibility to millions of companies who can promote themselves, recruit , sell their products / services.';
